<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tUtK0X/tc-custom/9781634868747.jpg?1718072539736" alt="This image is the cover for the book Controlled, Hot Flash"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Controlled, Hot Flash
      </h1>
      <p class="bookDescription body article font2">
        <p>He likes to think he’s in control. He always wants to be “in charge.” Which is fine by me. That’s what I want him to think.<br/><br/>Whenever life threatens to get in between us, when he’s so busy at work that he’s too tired to love me in the evenings, I know I have to take matters into my own hands.<br/><br/>But I have to be discreet. I want him, but I can’t let him know how much. I want him to want <i>me</i>.<br/><br/>And I always get what I want. So which of us is really in control?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J.M. Snyder
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c0b05a5c